import { useMemo } from "react"
import _ from "lodash"

import { PostData } from "providers/venue/types"
import {
  UseGetPostProps,
  useGetPosts,
} from "providers/venue/modules/data/posts/useGetPosts"

export const usePost = (
  categoryReference: string,
  options?: UseGetPostProps
) => {
  const { data, isFetched } = useGetPosts(options)

  const filteredPosts = useMemo(() => {
    if (!data) return []

    return data.filter((post: PostData) => {
      const postCategoryReference = _.get(
        post,
        "properties.category.properties.reference"
      )
      // TODO: Deprecate `postType`. It will be removed later.
      const postType = _.get(post, "properties.type")
      return (
        postCategoryReference === categoryReference ||
        postCategoryReference === postType
      )
    })
  }, [data, categoryReference])

  const hasData = _.size(filteredPosts) > 0

  return {
    hasData,
    postData: filteredPosts,
    isFetched,
  }
}
